<form [formGroup]="editarReservaForm" (ngSubmit)="onSubmit()">


  <!-- Horarios disponibles -->
  <div class="form-group" *ngIf="horariosDisponibles.length > 0">
    <label class="form-label">Horarios Disponibles</label>
    <div class="horarios-disponibles">
      <button
        *ngFor="let horario of horariosDisponibles"
        type="button"
        (click)="toggleHorario(horario.id_horario)"
        [class.selected]="selectedHorarios.includes(horario.id_horario)"
        class="btn btn-outline-primary"
      >
        {{ horario.hora_inicio }} - {{ horario.hora_fin }}
      </button>
    </div>
  </div>

  <div class="form-group">
    <label class="form-label">Cambiar Estado</label>
    <button
      type="button"
      class="btn btn-warning"
      (click)="updateEstadoNoPagado()"
    >
      No Pagado
    </button>
  </div>

  <!-- Botón para enviar los datos -->
  <div class="form-group">
    <button
      type="submit"
      class="btn btn-success"
      [disabled]="editarReservaForm.invalid || selectedHorarios.length === 0"
    >Guardar Cambios
    </button>
  </div>
</form>
